import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import FaIcon from '../../icon/FaIcon/FaIcon';
import Badge from '../Badge/Badge';
import styles from './LinkListItem.module.scss';

export interface LinkListItemProps {
  iconSrc: string;
  text: string;
  showBadge?: boolean;
  onClick: () => void;
  id?: string;
}

function LinkListItem({ iconSrc, text, showBadge = false, onClick, id }: LinkListItemProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick();
  };

  const testId = id ? `${id}-menu-item` : undefined;

  return (
    <button type='button' className={styles.componentStyle} onClick={handleClick} data-testid={testId}>
      <div className={styles.iconTextWrapper}>
        <img src={iconSrc} alt='icon' className={styles.icon} />
        &nbsp; {text}
        {showBadge && (
          <div className={styles.badge}>
            <Badge color='primary' />
          </div>
        )}
      </div>
      <FaIcon icon={faChevronRight} />
    </button>
  );
}

export { LinkListItem };
export default LinkListItem;
